import { render, staticRenderFns } from "./HybridDBEditor.vue?vue&type=template&id=475ca412&scoped=true"
import script from "./HybridDBEditor.vue?vue&type=script&lang=js"
export * from "./HybridDBEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475ca412",
  null
  
)

export default component.exports